import { COUNTRY_SETTINGS } from "./constants";
export const getCountrySetting = (countryCode) => {
  const countrySetting = COUNTRY_SETTINGS[countryCode] || COUNTRY_SETTINGS['DEFAULT'];
  return countrySetting;
};

export const calculatePriceWithDiscount = (price, coupon) => {
  const discount_amount = coupon.discount_type === 'fixed_amount' ? coupon.discount_amount : (price * coupon.discount_percentage) / 100;
  return discount_amount > price ? 0 : price - discount_amount; 
};

export const checkIfDiscountIsApplicableForProduct = (planId, product, coupon, isDiscountAppliedAlready) => {
  if(!coupon.isValid || (!coupon.meta_data?.applicableToMany && isDiscountAppliedAlready) || !coupon.meta_data.plan_ids || !coupon.meta_data.plan_ids.includes(planId) || !coupon.item_constraints){
    return false;
  };
  const itemConstraintsForCharge = coupon.item_constraints.find((constraint)=> constraint.item_type === 'charge');
  if(!itemConstraintsForCharge){
    return false;
  }
  const isDiscountApplicableToCharge = itemConstraintsForCharge.constraint === 'all' || (itemConstraintsForCharge.constraint === 'specific' && itemConstraintsForCharge.item_price_ids.includes(product))
  return isDiscountApplicableToCharge;
}

export const getTotalDiscountedAmount = (plan, products, isDiscountAppliedOnPlan)=> {
  if(isDiscountAppliedOnPlan){
    return plan.originalPrice - plan.price;
  }
  const productsTotalOriginalAmount = products.reduce(
    (total, product) => total + product.originalPrice * product.quantity,
    0
  );
  const productsTotalDiscountedAmount = products.reduce(
    (total, product) => total + product.price * product.quantity,
    0
  );

  return productsTotalOriginalAmount - productsTotalDiscountedAmount;
};